import { NgModule }   from '@angular/core';
import { Router, Routes, RouterModule } from '@angular/router';

import { PermissionsComponent } from './permissions.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UserPermissionsComponent } from './user-permissions/user-permissions.component';
import { GroupPermissionsComponent } from './group-permissions/group-permissions.component';
import { PermissionsReportComponent } from './permissions-report/permissions-report.component';
import { ComponentRegistrationComponent } from './component-registration/component-registration.component';
import { ManageUsersComponent } from './manage-users/manage-users.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { ComponentReportComponent } from './component-report/component-report.component';

const permissionsRoutes: Routes = [
    {
        path: "",
        component: PermissionsComponent,
        canActivateChild: [AuthGuard],
        children: [
            {
                path: '',
                children: [
                    { path: './', redirectTo: "", pathMatch: "full" },
                    { path: '', component: DashboardComponent },
                    { path: 'userPermissions', component: UserPermissionsComponent },
                    { path: 'groupPermissions', component: GroupPermissionsComponent },
                    { path: 'permissionsReport', component: PermissionsReportComponent },
                    { path: 'componentReport', component: ComponentReportComponent },
                    { path: 'componentRegistration', component: ComponentRegistrationComponent },
                    { path: 'manageUsers', component: ManageUsersComponent }
                ]
            }
        ]
    },

];

@NgModule({
    imports: [
        RouterModule.forChild(permissionsRoutes)
    ],
    exports: [
        RouterModule
    ]
})

export class PermissionsRoutingModule { }
